import { whiteColor } from 'assets/jss/material-dashboard-pro-react';

const numbersTabStyle = () => ({
	tab: {
		marginTop: '24px',
		backgroundColor: whiteColor,
		borderRadius: '8px',
	},
	searchWrapper: {
		marginTop: '24px',
	},
	tableContainer: {
		width: 'auto',
	},
	departmentSelect: {
		width: '30%',
	},
	departmentSelectValue: {
		paddingLeft: '4px',
	},
});

export default numbersTabStyle;
